export const  searchBarData=[
    {
      id:1,
      product:'Tecno camon 17'
    },
    {
      id:2,
      product:'Black view oscal pad 8'
    },
    {
      id:3,
      product:'Gionee M12'
    },
    {
      id:4,
      product:'Huawei y9a'
    },
    {
      id:5,
      product:'XIAOMI poco m4 pro'
    },
    {
      id:6,
      product:'Tecno POVA Neo'
    },
    {
      id:7,
      product:'Samsung Galaxy A23'
    },
    {
      id:8,
      product:'Infinix note 11 pro'
    },
    {
      id:9,
      product:'Huawei p8 max'
    },
    {
      id:10,
      product:'Tecno phantom X'
    },
    {
      id:11,
      product:'Iphone 12'
    },
    {
      id:12,
      product:'samsung galaxy s10 plus'
    },
    {
      id:13,
      product:'XIAOMI redmi note 9s'
    },
    {
      id:14,
      product:'Nokia 8.3'
    },
    {
      id:15,
      product:'Ouikitel c21'
    },
    {
      id:16,
      product:'Samsung galaxy A12'
    },
    {
      id:17,
      product:'Itel A35'
    },
    {
      id:18,
      product:'Gionee P15 Pro'
    },
    {
      id:19,
      product:'Apple ipad'
    },
    {
      id:20,
      product:'Gionee s12'
    },
  ]

export const phoneProductForHome=[
    {
        "no": 47,
        "id": "ce",
        "productname": "XIAOMI poco m4 pro",
        "productprice": 95000,
        "productinfo": null,
        "productimage1": "/skydome images/XIAOMI-img1.jpeg",
        "productimage2": "/skydome images/XIAOMI-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "5000mAh",
        "ram": "6gb",
        "rom": "128gb",
        "windowversion": "android version 11",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.42",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "16MP",
        "rearcamera": "64MP Triple camera",
        "shoesize": null,
        "productinfopreview":"XIAOMI poco m4 pro AMOLED Screen 6gb/126gb memory..."
    },
    {
        "no": 9,
        "id": "cf",
        "productname": "Tecno POVA Neo",
        "productprice": 76000,
        "productinfo": null,
        "productimage1": "/skydome images/Tecno POVA Neo-img1.jpeg",
        "productimage2": "/skydome images/Tecno POVA Neo-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "6000mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "Android 11",
        "color": "blaack",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.8",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "12MP",
        "rearcamera": "13MP Dual rear with quad flash",
        "shoesize": null,
        "productinfopreview":"Tecno POVA Neo (LE6) 6.8'' HD + 4GB RAM + 64GB ROM,6000..."
    },
    {
        "no": 10,
        "id": "cg",
        "productname": "Samsung Galaxy A23",
        "productprice": 150000,
        "productinfo": null,
        "productimage1": "/skydome images/samsung-galaxy-a23-img1.jpeg",
        "productimage2": "/skydome images/samsung-galaxy-a23-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "5000mAh",
        "ram": "4gb",
        "rom": "128gb",
        "windowversion": "android version 12 ",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.6",
        "gaminggraphics": null,
        "network": "5G/4G/3G/2G",
        "frontcamera": "8MP",
        "rearcamera": "50MP quad camera",
        "shoesize": null,
        "productinfopreview":"samsung galaxy a23 6.6 inch TFTscreen 4/128gbram memory"
    },
    {
        "no": 12,
        "id": "ch",
        "productname": "Infinix note 11 pro",
        "productprice": 148000,
        "productinfo": null,
        "productimage1": "/skydome images/Infinix note 11 pro-img1.jpeg",
        "productimage2": "/skydome images/Infinix note 11 pro-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "5000mAh",
        "ram": "8gb",
        "rom": "128gb",
        "windowversion": "android version 11",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.95",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "16MP ff Selfie with Dual flash",
        "rearcamera": "64MP 30X Telescope zoom",
        "shoesize": null,
        "productinfopreview":"infinix note 11 pro 5000mah 8gb ram 128gb rom,android 11"
    }
]

export const phoneProd=[
    {
        "no": 149,
        "id": "c5",
        "productname": "Iphone 12 pro max",
        "productprice": 630000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/iphone-12promax-img2.jpeg",
        "productimage2": "/skydome images/iphone-12promax-img1.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "3687mAh",
        "ram": "6gb",
        "rom": "256gb",
        "windowversion": "iOS 14.1",
        "color": "graphite",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.7",
        "gaminggraphics": null,
        "network": "5G",
        "frontcamera": "12MP",
        "rearcamera": "(12MP+12MP+12MP)",
        "shoesize": null,
        "productinfopreview":"Iphone 12 pro max 3687mAh 6gb ram ,256gb rom graphite.. "

    },
    {
        "no": 150,
        "id": "c6",
        "productname": "samsung galaxy s21 ultra",
        "productprice": 619000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/samsung-galaxy-s21-img2.jpeg",
        "productimage2": "/skydome images/samsung-galaxy-s21-img1.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "5000mAh",
        "ram": "12gb",
        "rom": "256gb",
        "windowversion": "android version 11 with one ui3.1",
        "color": "black",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.6",
        "gaminggraphics": null,
        "network": "5G",
        "frontcamera": "40MP",
        "rearcamera": "12MP Ultra Wide Camera, 108MP Wide-angle Camera, Double 10MP Telephoto Camera",
        "shoesize": null,
        "productinfopreview":"samsung galaxy s21 ultra 5000mAh 12gb ram 256gb... "

    },
    {
        "no": 151,
        "id": "c7",
        "productname": "samsung galaxy M51",
        "productprice": 195000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/samsung-galaxy-m51-img2.jpeg",
        "productimage2": "/skydome images/samsung-galaxy-m51-img1.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "7000mAh",
        "ram": "8gb",
        "rom": "128gb",
        "windowversion": "android version 10",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.7",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "32MP",
        "rearcamera": "(64MP+12MP+5MP+5MP)",
        "shoesize": null,
        "productinfopreview":"samsung galaxy M51 android version 10 8gb ram 128gb..."

    },
    {
        "no": 152,
        "id": "c8",
        "productname": "infinix s5 pro",
        "productprice": 87000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/infinix-s5-pro-img2.jpeg",
        "productimage2": "/skydome images/infinix-s5-pro-img1.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4000mAh",
        "ram": "6gb",
        "rom": "128gb",
        "windowversion": "android version 10",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.53",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "40MP",
        "rearcamera": "48MP/2MP/QVGA",
        "shoesize": null,
        "productinfopreview":"infinix s5 pro 4000mAh 6gb ram 128gb rom android ve..."

    },
    {
        "no": 82,
        "id": "c1-phone",
        "productname": "Tecno camon 17",
        "productprice": 87000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c1-phone-img1.jpeg",
        "productimage2": "/skydome images/c1-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "5000mAh",
        "ram": "4gb",
        "rom": "128gb",
        "windowversion": "android version 11",
        "color": "Frost silver",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.6",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "8MP",
        "rearcamera": "48MP triple rear",
        "shoesize": null,
        "productinfopreview":"Tecno camon 17 (CG6) 6.6' 90Hz HD+,4GB ram 128gb rom..."
    },
    {
        "no": 83,
        "id": "c2-phone",
        "productname": "Black view oscal pad 8",
        "productprice": 69000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c2-phone-img1.jpeg",
        "productimage2": "/skydome images/c2-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "6580mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "android version 11",
        "color": "Tablet grey",
        "touchscreen": null,
        "netweight": null,
        "inch": "10.1",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "2MP",
        "rearcamera": "4MP triple rear",
        "shoesize": null,
        "productinfopreview":"Blackview Oscal Pad 8 10.1' 4GB+64GB Android 11 4G..."
    },
    {
        "no": 84,
        "id": "c3-phone",
        "productname": "Gionee M12",
        "productprice": 84000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c3-phone-img1.jpeg",
        "productimage2": "/skydome images/c3-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "5100mAh",
        "ram": "6gb",
        "rom": "128gb",
        "windowversion": "android version 10",
        "color": "Tablet grey",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.55",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "16MP",
        "rearcamera": " Quad Camera: 48MP + 5MP + 2MP + 2MP",
        "shoesize": null,
        "productinfopreview":"Gionee M12, 6.55-Inch HD+ (6GB RAM, 128GB ROM) Androi.."
    },
    {
        "no": 85,
        "id": "c4-phone",
        "productname": "Huawei y9a",
        "productprice": 157000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c4-phone-img1.jpeg",
        "productimage2": "/skydome images/c4-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4300mAh",
        "ram": "8gb",
        "rom": "128gb",
        "windowversion": "android version 10",
        "color": "Saruka pink",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.63",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "16MP",
        "rearcamera": "64MP + 8MP + 2MP + 2MP",
        "shoesize": null,
        "productinfopreview":"Huawei Y9a, 6.63-Inch (8GB RAM + 128GB ROM) Android..."
    },
    {
        "no": 47,
        "id": "cq",
        "productname": "XIAOMI poco m4 pro",
        "productprice": 95000,
        "productinfo": null,
        "productimage1": "/skydome images/XIAOMI-img1.jpeg",
        "productimage2": "/skydome images/XIAOMI-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "5000mAh",
        "ram": "6gb",
        "rom": "128gb",
        "windowversion": "android version 11",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.42",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "16MP",
        "rearcamera": "64MP Triple camera",
        "shoesize": null,
        "productinfopreview":"XIAOMI poco m4 pro AMOLED Screen 6gb/126gb memory..."
    },
    {
        "no": 9,
        "id": "cr",
        "productname": "Tecno POVA Neo",
        "productprice": 76000,
        "productinfo": null,
        "productimage1": "/skydome images/Tecno POVA Neo-img1.jpeg",
        "productimage2": "/skydome images/Tecno POVA Neo-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "6000mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "Android 11",
        "color": "blaack",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.8",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "12MP",
        "rearcamera": "13MP Dual rear with quad flash",
        "shoesize": null,
        "productinfopreview":"Tecno POVA Neo (LE6) 6.8'' HD + 4GB RAM + 64GB ROM,6000..."
    },
    {
        "no": 10,
        "id": "cs",
        "productname": "Samsung Galaxy A23",
        "productprice": 150000,
        "productinfo": null,
        "productimage1": "/skydome images/samsung-galaxy-a23-img1.jpeg",
        "productimage2": "/skydome images/samsung-galaxy-a23-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "5000mAh",
        "ram": "4gb",
        "rom": "128gb",
        "windowversion": "android version 12 ",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.6",
        "gaminggraphics": null,
        "network": "5G/4G/3G/2G",
        "frontcamera": "8MP",
        "rearcamera": "50MP quad camera",
        "shoesize": null,
        "productinfopreview":"samsung galaxy a23 6.6 inch TFTscreen 4/128gbram memory"
    },
    {
        "no": 12,
        "id": "ct",
        "productname": "Infinix note 11 pro",
        "productprice": 148000,
        "productinfo": null,
        "productimage1": "/skydome images/Infinix note 11 pro-img1.jpeg",
        "productimage2": "/skydome images/Infinix note 11 pro-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "quantity":1,
        "batteryinfo": "5000mAh",
        "ram": "8gb",
        "rom": "128gb",
        "windowversion": "android version 11",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.95",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "16MP ff Selfie with Dual flash",
        "rearcamera": "64MP 30X Telescope zoom",
        "shoesize": null,
        "productinfopreview":"infinix note 11 pro 5000mah 8gb ram 128gb rom,android 11"
    },
    {
        "no": 86,
        "id": "c5-phone",
        "productname": "Huawei p8 max",
        "productprice": 65000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c5-phone-img1.jpeg",
        "productimage2": "/skydome images/c5-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4360mAh",
        "ram": "3gb",
        "rom": "32gb",
        "windowversion": "android version 5.0 + emotion UI 3.1",
        "color": "silver",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.8",
        "gaminggraphics": null,
        "network": "4G-LTE",
        "frontcamera": "8MP",
        "rearcamera": "32MP",
        "shoesize": null,
        "productinfopreview":"Huawei P8 Max 6.8' Inch 4G LTE Android IPS 3gb ram..."
    },
    {
        "no": 87,
        "id": "c6-phone",
        "productname": "Tecno phantom X",
        "productprice": 249000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c6-phone-img1.jpeg",
        "productimage2": "/skydome images/c6-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4700mAh",
        "ram": "8gb",
        "rom": "256gb",
        "windowversion": "android version 11",
        "color": "sunset",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.7",
        "gaminggraphics": null,
        "network": "4G-LTE",
        "frontcamera": "48MP + 8MP",
        "rearcamera": "50MP+13MP+8MP",
        "shoesize": null,
        "productinfopreview":"Tecno Phantom X 6.7-Inch, 256GB ROM,8GB RAM Android..."
    },
    {
        "no": 88,
        "id": "c7-phone",
        "productname": "Iphone 12",
        "productprice": 427000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c7-phone-img1.jpeg",
        "productimage2": "/skydome images/c7-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "2815mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "ios 14.1",
        "color": "Blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.1",
        "gaminggraphics": null,
        "network": "5G",
        "frontcamera": "48MP + 12MP",
        "rearcamera": "12MP+12MP",
        "shoesize": null,
        "productinfopreview":"Apple Iphone 12 6.1 Inches-4GB RAM, 64GB ROM, 2815mAh,5G"
    },
    {
        "no": 89,
        "id": "c8-phone",
        "productname": "samsung galaxy s10 plus",
        "productprice": 220000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c8-phone-img1.jpeg",
        "productimage2": "/skydome images/c8-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4100mAh",
        "ram": "8gb",
        "rom": "128gb",
        "windowversion": "android 9.0",
        "color": "white",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.4",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "8MP + 12MP",
        "rearcamera": "12MP+16MP",
        "shoesize": null,
        "productinfopreview":"Samsung Galaxy S10 Plus (S10+) 6.4-Inch AMOLED..."
    },
    {
        "no": 90,
        "id": "c9-phone",
        "productname": "XIAOMI redmi note 9s",
        "productprice": 130000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c9-phone-img1.jpeg",
        "productimage2": "/skydome images/c9-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "5020mAh",
        "ram": "6gb",
        "rom": "128gb",
        "windowversion": "MIUI",
        "color": "Auorora blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.67",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "16MP",
        "rearcamera": "48MP+8MP+5MP+2MP",
        "shoesize": null,
        "productinfopreview":"XIAOMI Redmi Note 9s 6GB 128GB, 48MP+8MP+5MP+2MP..."
    },
    {
        "no": 91,
        "id": "c10-phone",
        "productname": "Nokia 8.3",
        "productprice": 225000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c10-phone-img1.jpeg",
        "productimage2": "/skydome images/c10-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4500mAh",
        "ram": "8gb",
        "rom": "128gb",
        "windowversion": "android 10",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.81",
        "gaminggraphics": null,
        "network": "5G",
        "frontcamera": "24MP",
        "rearcamera": "64MP+12MP+2MP+2MP",
        "shoesize": null,
        "productinfopreview":"Nokia 8.3 8/128 GB, 6.81' FHD+, Dual SIM, 64/12/2/2MP.."
    },
    {
        "no": 92,
        "id": "c11-phone",
        "productname": "Ouikitel c21",
        "productprice": 57800,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c11-phone-img1.jpeg",
        "productimage2": "/skydome images/c11-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4000mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "android 10",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.4",
        "gaminggraphics": null,
        "network": "4G",
        "frontcamera": "20MP AI selfie",
        "rearcamera": "16MP Matrix Quad Camera",
        "shoesize": null,
        "productinfopreview":"Oukitel C21 4G 6.4” FHD ( 64GB ROM 4GB RAM) 20 MP AI..."
    },
    {
        "no": 93,
        "id": "c12-phone",
        "productname": "Samsung galaxy A12",
        "productprice": 87500,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c12-phone-img1.jpeg",
        "productimage2": "/skydome images/c12-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "5000mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "android 10",
        "color": "black",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.5",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "8MP",
        "rearcamera": "48MP+5MP+5MP+2MP",
        "shoesize": null,
        "productinfopreview":"Samsung Galaxy A12(A125F/DS)- 6.5' 48MP Camera 4/64gb ..."
    },
    {
        "no": 94,
        "id": "c13-phone",
        "productname": "Itel A35",
        "productprice": 26000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c13-phone-img1.jpeg",
        "productimage2": "/skydome images/c13-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "3020mAh",
        "ram": "1gb",
        "rom": "16gb",
        "windowversion": "android 10",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "5.0",
        "gaminggraphics": null,
        "network": "3G",
        "frontcamera": "8MP",
        "rearcamera": "2MP",
        "shoesize": null,
        "productinfopreview":"Itel A35 5.0' HD Screen, 1GB RAM + 16GB ROM, Android 10..."
    },
    {
        "no": 95,
        "id": "c14-phone",
        "productname": "Gionee P15 Pro",
        "productprice": 64900,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c14-phone-img1.jpeg",
        "productimage2": "/skydome images/c14-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "6000mAh",
        "ram": "3gb",
        "rom": "64gb",
        "windowversion": "android 11",
        "color": "Fjord",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.8",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "8MP",
        "rearcamera": "13MP+2MP+0.1MPdepth with LED flash",
        "shoesize": null,
        "productinfopreview":"Gionee P15 PRO-6.82'HD+ V-NOTCH DISPLAY-64GB ROM/3GB..."
    },
    {
        "no": 98,
        "id": "c15-phone",
        "productname": "Apple ipad",
        "productprice": 217000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c15-phone-img1.jpeg",
        "productimage2": "/skydome images/c15-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4000mAh",
        "ram": "3gb",
        "rom": "32gb",
        "windowversion": "IOS",
        "color": "Space grey",
        "touchscreen": null,
        "netweight": null,
        "inch": "10.2",
        "gaminggraphics": null,
        "network": "Wifi",
        "frontcamera": "2MP",
        "rearcamera": "5MP",
        "shoesize": null,
        "productinfopreview":"Apple Ipad 7th (2019) 10.2 Inches,3GB+32GB,Space Gray..."
    },
    {
        "no": 99,
        "id": "c16-phone",
        "productname": "Gionee s12",
        "productprice": 58900,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c16-phone-img1.jpeg",
        "productimage2": "/skydome images/c16-phone-img2.jpeg",
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": "4000mAh",
        "ram": "4gb",
        "rom": "64gb",
        "windowversion": "android 10",
        "color": "blue",
        "touchscreen": null,
        "netweight": null,
        "inch": "6.5",
        "gaminggraphics": null,
        "network": "4G LTE",
        "frontcamera": "13MP",
        "rearcamera": "(16+8+2+2MP Quad Rear Camera)",
        "shoesize": null,
        "productinfopreview":"Gionee S12 6.517-Inch HD (4GB RAM, 64GB ROM) Android 10..."
    }
]
